import React, { Component } from 'react';
import { apiGet } from '../../Api';

const DEFAULT_ENEMY_TYPE_COLOR = '#9ca3af';

export default class EnemyTypeDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageFile: null,
            imagePreviewUrl: '',
            enemytype: null
        };
    }


    componentDidUpdate = async (prevProps, prevState) => {
        console.log("update");
        if (this.props.enemytypeId !== prevProps.enemytypeId || this.props.creatingNewEnemyType !== prevProps.creatingNewEnemyType) {
            this.setState({ imageFile: null, imagePreviewUrl: null });
            this.getEnemyType();

        }
    }


    getEnemyType = async () => {
        if (this.props.enemytypeId != null) {
            if (this.props.enemytypeId === "") {
                // this.setState({ enemytype: null });
                this.setState({
                    enemytype: {
                        name: "",
                        shortName: "",
                        flavourText: "",
                        orderIndex: 100,
                        imageId: "",
                        colorHex: DEFAULT_ENEMY_TYPE_COLOR,
                        statPowerMultiplier: 1,
                    },
                    imageFile: null,
                    imagePreviewUrl: "",
                });
            }
            else {
                const response = await apiGet("/enemytype/" + this.props.enemytypeId);
                if (response.ok) {
                    const curr = await response.json();
                    this.fixdropchance(curr);
                    // this.setState({ enemytype: curr });
                    if (curr.imageId) {
                        this.fetchImage();
                    }
                }
            }
        }
        else {
            this.setState({ enemytype: null });
        }
    }

    fixdropchance = (enemytype) => {
        const { rarities } = this.props;
        enemytype.colorHex = /^#[0-9a-f]{6}$/i.test(enemytype.colorHex || '')
            ? enemytype.colorHex
            : DEFAULT_ENEMY_TYPE_COLOR;
        // var { enemytype } = this.state;
        var newrarityDropChanceModifier = [];
        for (var i = 0; i < rarities.length; i++) {
            const rarity = rarities[i];
            const dropChanceModifier = enemytype.rarityDropChanceModifier
                ?.find(modifier => modifier.rarityId === rarity.id)
                ?.dropChanceModifier ?? 1;
            newrarityDropChanceModifier.push({ rarityId: rarity.id, dropChanceModifier: dropChanceModifier });
        }
        enemytype.rarityDropChanceModifier = newrarityDropChanceModifier;

        this.setState({ enemytype });
    }


    handleInputChange = (event) => {
        const name = event.target.name;
        let value = event.target.value;
        if (event.target.type === "checkbox") {
            value = event.target.checked;
        } else if (event.target.type === "number") {
            const parsed = Number.parseFloat(event.target.value);
            value = Number.isFinite(parsed) ? parsed : 0;
        }
        else {
            value = event.target.value;
        }
        const enemytype = { ...this.state.enemytype, [name]: value };
        this.setState({ enemytype });
    };


    handleDropChanceChange = (event, rarityId) => {
        const { value } = event.target;
        //if there is no rarityDropChanceModifier for itemTypeId, create it
        if (!this.state.enemytype.rarityDropChanceModifier?.find(modifier => modifier.rarityId === rarityId)) {
            const rarityDropChanceModifier = this.state.enemytype.rarityDropChanceModifier || [];
            rarityDropChanceModifier.push({ rarityId: rarityId, dropChanceModifier: parseFloat(value) });
            const enemytype = { ...this.state.enemytype, rarityDropChanceModifier };
            this.setState({ enemytype });
            return;
        }
        else {

            const rarityDropChanceModifier = this.state.enemytype.rarityDropChanceModifier?.map(modifier => {
                if (modifier.rarityId === rarityId) {
                    return { ...modifier, dropChanceModifier: parseFloat(value) };
                }
                return modifier;
            });
            const enemytype = { ...this.state.enemytype, rarityDropChanceModifier };
            this.setState({ enemytype });
        }
    };

    render() {
        const { onUpdate, onDelete, onCreate, creatingNewEnemyType, onCancelCreate, rarities } = this.props;
        const { enemytype } = this.state;

        if (!enemytype || enemytype == null) return <div>Select a enemytype to see details</div>;
        const isColorValid = /^#[0-9a-f]{6}$/i.test(enemytype.colorHex || '');
        const isStatPowerMultiplierValid = Number(enemytype.statPowerMultiplier) > 0;

        return (
            <div className='admin_details'>
                <label>Name:
                    <input type="text" name="name" value={enemytype.name} onChange={this.handleInputChange} />
                </label>
                <label>Outline Color:
                    <div className="admin-color-field">
                        <input
                            type="color"
                            name="colorHex"
                            value={isColorValid ? enemytype.colorHex : DEFAULT_ENEMY_TYPE_COLOR}
                            onChange={this.handleInputChange}
                            aria-label="Enemy type outline color"
                        />
                        <input
                            type="text"
                            name="colorHex"
                            value={enemytype.colorHex}
                            onChange={this.handleInputChange}
                            pattern="#[0-9a-fA-F]{6}"
                            aria-invalid={!isColorValid}
                            aria-label="Enemy type outline color hex value"
                        />
                    </div>
                    {!isColorValid && <span role="alert">Use a six-digit hex color such as #f59e0b.</span>}
                </label>
                <label>Spawn Chance:
                    <input type="number" step="0.01" name="spawnchance" value={enemytype.spawnchance} onChange={this.handleInputChange} />

                </label>
                <label>MaxPercentageOfValueOfStats:
                    <input type="number" step="0.01" name="maxPercentageOfValueOfStats" value={enemytype.maxPercentageOfValueOfStats} onChange={this.handleInputChange} />

                </label>
                <label>Stat Power Multiplier:
                    <input
                        type="number"
                        min="0.01"
                        step="0.01"
                        name="statPowerMultiplier"
                        value={enemytype.statPowerMultiplier ?? 1}
                        aria-invalid={!isStatPowerMultiplierValid}
                        onChange={this.handleInputChange}
                    />
                    {!isStatPowerMultiplierValid && (
                        <span role="alert">Stat power multiplier must be greater than zero.</span>
                    )}
                </label>

                <label>DropChanceModifier:
                    {/* <input type="number" step="0.01" name="dropChanceModifier" value={enemytype.dropChanceModifier} onChange={this.handleInputChange} /> */}

                </label>

                {rarities?.map(rarity => (
                    <div key={rarity.id}>
                        <label>{rarity.name} Drop Chance:
                            <input
                                type="number"
                                step="0.01"
                                value={enemytype.rarityDropChanceModifier?.find(modifier => modifier.rarityId === rarity.id)?.dropChanceModifier ?? 1}
                                onChange={(event) => this.handleDropChanceChange(event, rarity.id)}
                            />
                        </label>
                    </div>
                ))}

                {creatingNewEnemyType ?
                    <div>
                        {/* Form to create a new enemytype, similar to the update form... */}
                        <button disabled={!isColorValid || !isStatPowerMultiplierValid} onClick={() => onCreate(enemytype)}>Create</button>
                        <button onClick={() => onCancelCreate()}>Cancel</button>
                    </div>
                    :
                    <div>
                        <button disabled={!isColorValid || !isStatPowerMultiplierValid} onClick={() => onUpdate(enemytype)}>Update</button>
                        <button onClick={() => onDelete(enemytype)}>Delete</button>
                    </div>
                }


            </div>
        );


    }

}
